require('./brokerRightsBuyStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const moment = require('moment');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @utilities
const { formatAmount } = require('utilities/currencyHelper');

// @components
const BrokerOrderTypeCheckbox = require('components/broker/brokerOrderTypeCheckbox/brokerOrderTypeCheckbox');
const { BrokerMiFIDBehaviorIgnoringPreviousResults } = require('mifid/components/brokerMiFIDBehaviorIgnoringPreviousResults/brokerMiFIDBehaviorIgnoringPreviousResults');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @commons
const { InputSafe } = require('commonsComponents/inputSafe');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { AmountInput } = require('commonsComponents/amountInput');

// @actions
const BrokerRightsBuyActions = require('actions/brokerRightsBuy');

// @constants
const {
    FIRST_STEP,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_RIGHTS_BUY_FIELDS_MAXLENGHT_LIMIT,
    SATURDAY_INDEX_DAY,
    SUNDAY_INDEX_DAY,
    EURO_TEXT,
    HYPHEN,
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_CORPORATE_OPERATIONS_BUY_RIGHTS_URL,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_RIGHTS_BUY,
    BROKER_MIFID_VERSION_2,
    BROKER_CORPORATE_OPEATIONS_MIFID_ID,
    BROKER_TYPE_RIGHT_NEW_DECIMALS,
    MYPROFILE_BROKER_URL
} = require('constants/index');
const nonNumericRegex = /[^\d]/g;
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class BrokerRightsBuyStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleRightsQuantityChanged = this.handleRightsQuantityChanged.bind(this);
        this.onLimitedValueChanged = this.onLimitedValueChanged.bind(this);
    }

    onLimitedValueChanged(value) {
        this.props.limitedValueChanged(value);
    }

    builExcludeDates(maxDate) {
        const limitDate = moment(maxDate).add(1, 'days');
        let excludeDates = [];
        let tempDate = moment();

        while (tempDate.isSameOrBefore(limitDate)) {
            const dayOfWeek = tempDate.day();

            if (dayOfWeek === SUNDAY_INDEX_DAY || dayOfWeek === SATURDAY_INDEX_DAY) {
                excludeDates.push(tempDate.clone());
            }

            tempDate = tempDate.add(1, 'days');
        }

        return excludeDates;
    }

    conditionalInput() {
        const { immBrokerRightsBuy, catalogData } = this.props;
        const limitedValue = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'orderTypeValue']);
        const limitedLabel = catalogData.get('operatedByLot') ?
            (
                <div className="stocks-buy-step1__input-foot">
                    {formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_rightsLimitPrice')}
                </div>
            ) : null;

        return (
            <div className="stocks-sell-step1__text-input-wrapper">
                <AmountInput
                    min={0}
                    amount={limitedValue}
                    callback={this.onLimitedValueChanged}
                    max={BROKER_RIGHTS_BUY_FIELDS_MAXLENGHT_LIMIT}
                    maxBackEndFractionLength={BROKER_TYPE_RIGHT_NEW_DECIMALS}
                    hideFocusZero={true}
                    language={language}
                />
                {limitedLabel}
            </div>
        );
    }

    handleRightsQuantityChanged(event) {
        const value = event.target.value.replace(nonNumericRegex, '').trim();
        this.props.rightsQuantityChanged(value);
    }

    buildContent() {
        const { immBrokerRightsBuy, validityDateChanged, orderTypeChanged, maxDate, catalogData } = this.props;
        const step1 = immBrokerRightsBuy.get('steps').get(FIRST_STEP);
        const rightsQuantity = step1.get('rightsQuantity');
        const rightsQuantityIsValid = step1.get('rightsQuantityIsValid');
        const rightsQuantityDirty = step1.get('rightsQuantityDirty');
        const minorThanLote = step1.getIn(['errorFlags', 'minorThanLote']);
        const notMultiploLote = step1.getIn(['errorFlags', 'notMultiploLote']);
        const validityDate = step1.get('validityDate');
        const orderTypeOption = step1.get('orderTypeOption');
        const excludeDates = this.builExcludeDates(maxDate);

        let limitedInput;
        let tooltipLot = null;
        let operatedByLotLabel;
        let inputFootValidator;
        let errorMessage = formatText('broker-rightsBuyStep1ErrorText');

        if (orderTypeOption === BROKER_ORDER_TYPE_LIMITED) {
            limitedInput = this.conditionalInput();
        }

        if (catalogData.get('operatedByLot')) {
            tooltipLot = (
                <OKTooltip
                    iconClass="icon icon-pregunta"
                    offset={[0, -5]}
                    content={formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_operatedByLotsRights')}
                />
            );

            const valueLabel = formatAmount(Number((rightsQuantity * catalogData.get('lotValue') / catalogData.get('lot')).toFixed(3)));
            operatedByLotLabel = <FormattedText className="stocks-buy-step1__input-foot"  value="brokerOperacionPorLotes-brokerOperacionPorLotes_buyByRights" injectedStrings={[catalogData.get('lot'), valueLabel]}/>;

            if(!rightsQuantityIsValid && !rightsQuantityDirty) {
                errorMessage = formatText('broker-rightsBuyStep1ErrorText');
            } else {
                if (notMultiploLote && !minorThanLote) {
                    errorMessage = formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_notMultiploRights');
                }
                if (minorThanLote) {
                    errorMessage = <FormattedText value="brokerOperacionPorLotes-brokerOperacionPorLotes_notEnoughRightsForLotError" injectedStrings={[catalogData.get('lot')]}/>;
                }
            }
            inputFootValidator = (notMultiploLote || minorThanLote) ? undefined : operatedByLotLabel;
        }

        return (
            <article className="broker-rights-buy-step1">
                <header className="broker-rights-buy-step1__header">
                    <h2 className="broker-rights-buy-step1__header-title">
                        <FormattedText value="broker-rightsBuyStep1HeaderTitle" />
                    </h2>
                    <h4 className="broker-rights-buy-step1__header-subtitle">
                        <FormattedText value="broker-rightsBuyStep1HeaderSubtitle" />
                    </h4>
                </header>
                <div className="broker-rights-buy-step1__group-div">
                    <h2 className="broker-rights-buy-step1__subtitle">
                        <FormattedText
                            value="broker-rightsBuyStep1RightsAmountText"
                            className="broker-rights-buy-step1__subtitle-text"
                        />
                        {tooltipLot}
                    </h2>
                    <div className="broker-rights-buy-step1__input-container">
                        <InputSafe
                            value={rightsQuantity}
                            autoComplete="off"
                            onChange={this.handleRightsQuantityChanged}
                            errorState={!rightsQuantityIsValid && !rightsQuantityDirty || minorThanLote || notMultiploLote}
                            errorMessage={errorMessage}
                        />
                        {inputFootValidator}
                    </div>
                </div>
                <div className="broker-rights-buy-step1__group-div">
                    <div className="broker-rights-buy-step1__datepicker-label">
                        <h2 className="broker-rights-buy-step1__subtitle">
                            <FormattedText
                                value="broker-rightsBuyStep1TermOfValidityText"
                                className="broker-rights-buy-step1__subtitle-text"
                            />
                        </h2>
                    </div>
                    <div className="broker-rights-buy-step1__date-picker">
                        <DatePickerCustom
                            callback={validityDateChanged}
                            selectedDate={validityDate}
                            maxDate={moment(maxDate).endOf('day')}
                            excludeDates={excludeDates}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </div>
                <div className="broker-rights-buy-step1__group-div">
                    <h2 className="broker-rights-buy-step1__subtitle">
                        <FormattedText
                            value="broker-rightsBuyStep1OrderTypeText"
                            className="broker-rights-buy-step1__subtitle-text"
                        />
                    </h2>
                    <BrokerOrderTypeCheckbox
                        onChange={orderTypeChanged}
                        value={orderTypeOption}
                        productCurrency={EURO_TEXT}
                    />
                    {limitedInput}
                </div>
            </article>
        );
    }

    buildMifidBreadcrumb() {
        return [
            {
                text: formatText('breadcrumb-brokerMyWallet'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('corporatesOperations-corporatesOperations'),
                url: BROKER_CORPORATE_OPERATIONS_URL
            }
        ];
    }

    wrapContentWithMifid(content) {
        const { immBrokerRightsBuy, immCorporatesOperations } = this.props;

        const immOperation = immCorporatesOperations.getIn([
            'selectedContract',
            'operations',
            immBrokerRightsBuy.get('selectedCorporateOperationIndex')
        ]);

        const productName = HYPHEN;
        const productUrl = BROKER_CORPORATE_OPERATIONS_URL;
        const continuationUrl = BROKER_CORPORATE_OPERATIONS_BUY_RIGHTS_URL;
        const productIsin = immOperation ? immOperation.get('isin') : '';
        const productIso = immOperation ? immOperation.get('iso') : '';
        const feeNumbers = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'rightsQuantity']);
        const valueCode = immOperation ? immOperation.get('linkId') : undefined;
        const eventCode = immOperation ? immOperation.get('eventCode') : undefined;
        const mifidOptions = {
            operationType: BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_RIGHTS_BUY,
            operationData: immBrokerRightsBuy.toJS(),
            breadcrumb: this.buildMifidBreadcrumb()
        };

        return (
            <BrokerMiFIDBehaviorIgnoringPreviousResults
                mifidVersion={BROKER_MIFID_VERSION_2}
                displayWhileLoading={false}
                productName={productName}
                productUrl={productUrl}
                continuationUrl={continuationUrl}
                productIsinId={productIsin}
                productMarketId={productIso}
                productMifidId={BROKER_CORPORATE_OPEATIONS_MIFID_ID}
                feeNumbers={feeNumbers}
                valueCode={valueCode}
                eventCode={eventCode}
                mifidOptions={mifidOptions}
            >
                {content}
            </BrokerMiFIDBehaviorIgnoringPreviousResults>
        );
    }

    buildContentWithMifidIfRequired() {
        const { immBrokerRightsBuy } = this.props;
        const mustRunMifid = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'mustRunMifid']);
        const content = this.buildContent();

        if (mustRunMifid) {
            return this.wrapContentWithMifid(content);
        } else {
            return content;
        }
    }

    render() {
        return this.buildContentWithMifidIfRequired();
    }
}

BrokerRightsBuyStep1.propTypes = {
    immBrokerRightsBuy: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    maxDate: PropTypes.object.isRequired,
    rightsQuantityChanged: PropTypes.func.isRequired,
    validityDateChanged: PropTypes.func.isRequired,
    orderTypeChanged: PropTypes.func.isRequired,
    limitedValueChanged: PropTypes.func.isRequired,
    catalogData: PropTypes.object.isRequired
};

module.exports.constructor = BrokerRightsBuyStep1;

module.exports.BrokerRightsBuyStep1 = connect(
    (state) => ({
        immCorporatesOperations: state.brokerCorporatesOperations
    }),
    {
        rightsQuantityChanged: BrokerRightsBuyActions.rightsQuantityChanged,
        validityDateChanged: BrokerRightsBuyActions.validityDateChanged,
        orderTypeChanged: BrokerRightsBuyActions.orderTypeChanged,
        limitedValueChanged: BrokerRightsBuyActions.limitedValueChanged
    }
)(BrokerRightsBuyStep1);
